import dashboardLoggerActions from "./actions";
const initialState = {
  logs: {
    loading: false,
    response: [],
    error: null,
  },
};

export default function dashboardLoggerReducer(state = initialState, action) {
  switch (action.type) {
    case dashboardLoggerActions.getDashboardLogs().type:
      return {
        ...state,
        logs: { ...state.logs, loading: true, error: null },
      };

    case dashboardLoggerActions.getDashboardLogsSuccess().type:
      return {
        ...state,
        logs: { loading: false, response: action.payload.data, error: null },
      };

    case dashboardLoggerActions.getDashboardLogsFailure().type:
      return {
        ...state,
        logs: { loading: false, response: [], error: action.payload.error },
      };

    default:
      return state;
  }
}
